import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { Col, Label, Row } from 'reactstrap';
import { Toggle } from 'components/Common/Toggle';
import { HelpText } from 'components/HelpText';

export const OrderTypeEditDates = () => {
  const { t } = useTranslation();
  const formik = useFormikContext();

  const toggleCheckbox = field => {
    formik.setFieldValue(field, !formik.values[field]);
  };

  const sections = [
    {
      title: 'Documents from consulate',
      description:
        'Documents received back from the consulate after processing',
      estimated: 'enableDocumentsFromConsEstimatedAt',
      estimatedWarning: '',
      actual: 'enableDocumentsFromConsActualAt',
      actualWarning: '',
    },
    {
      title: 'Documents to consulate',
      description: 'Documents sent to the consulate for processing',
      estimated: 'enableDocumentsToConsEstimatedAt',
      estimatedWarning: '',
      actual: 'enableDocumentsToConsActualAt',
      actualWarning: '',
    },
    {
      title: 'Documents to applicant',
      description: 'Documents returned to the applicant after completion',
      estimated: 'enableDocumentsToApplicantEstimatedAt',
      estimatedWarning: 'When do you need your documents back?',
      actual: 'enableDocumentsToApplicantActualAt',
      actualWarning: '',
    },
  ];

  return (
    <>
      {sections.map((section, idx) => (
        <Row
          key={idx}
          className="d-flex mt-3 flex-wrap align-items-center py-2 border-bottom"
        >
          <Col xs={12} xl={4} className="p-0">
            <Label className="m-0 fw-semibold">{section.title}</Label>
            {section.description && (
              <HelpText size="sm" noBackground hideIcon>
                {section.description}
              </HelpText>
            )}
          </Col>

          <Col xs={6} xl={4} className="p-0 d-flex align-items-center gap-3">
            <Toggle
              checked={formik.values[section.estimated]}
              onChange={() => toggleCheckbox(section.estimated)}
              label="Estimated"
              warning={section.estimatedWarning}
            />
          </Col>

          <Col xs={6} xl={4} className="p-0 d-flex align-items-center gap-3">
            <Toggle
              checked={formik.values[section.actual]}
              onChange={() => toggleCheckbox(section.actual)}
              label="Actual"
              warning={section.actualWarning}
            />
          </Col>
        </Row>
      ))}

      <Row className="d-flex mt-3 flex-wrap align-items-center py-2 border-bottom">
        <Col xs={12} xl={4} className="p-0">
          <Label className="m-0 fw-semibold">Validity / Gültig</Label>
          <span
            className="d-block text-muted small"
            style={{ fontSize: '11px' }}
          >
            Validity period of the visa (start and end dates)
          </span>
        </Col>
        <Col xs={6} xl={4} className="p-0 d-flex align-items-center gap-3">
          <Toggle
            checked={formik.values.enableGultigFrom}
            onChange={() => toggleCheckbox('enableGultigFrom')}
            label="From"
          />
        </Col>
        <Col xs={6} xl={4} className="p-0 d-flex align-items-center gap-3">
          <Toggle
            checked={formik.values.enableGultigTo}
            onChange={() => toggleCheckbox('enableGultigTo')}
            label="To"
          />
        </Col>
      </Row>

      {/* First Date of Entry - Full width with better spacing */}
      <Row className="d-flex mt-3 flex-wrap align-items-center py-2">
        <Col xs={12} xl={4} className="p-0">
          <div>
            <span className="fw-semibold">
              {t('orderTypes.enableFirstDateOfEntry')}
            </span>
            <span
              className="text-muted small d-block"
              style={{ fontSize: '11px' }}
            >
              First date the traveler can enter the country
            </span>
          </div>
        </Col>
        <Col xs={6} xl={4} className="p-0 d-flex align-items-center">
          <Toggle
            checked={formik.values.enableFirstDateOfEntry}
            onChange={() => toggleCheckbox('enableFirstDateOfEntry')}
            label=""
            warning=""
          />
        </Col>
        <Col xs={6} xl={4} className="p-0">
          {/* Empty column to maintain alignment with the 3-column layout above */}
        </Col>
      </Row>
    </>
  );
};
